<template>
  <div class="container mx-auto h-full md:flex justify-center items-center m-8">
    <div class="md:w-1/2">
      <h1 class="font-hairline mb-6 text-center">Anmelden</h1>
      <div v-if="error" @click="close" class="mb-4 bg-red-lightest border border-red-light text-red-dark px-4 py-3 rounded relative" role="alert">
        <span class="block sm:inline">{{error}}</span>
      </div>
      <div class="p-4">
        <button @click="signInWithGoogle" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Google</button>
        <button @click="signInWithFacebook" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Facebook</button>
        <button @click="signInWithPhone" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Handy</button>
      </div>
      <div class="p-8">
        <form v-on:submit.prevent="signIn">
          <div class="mb-4">
            <label class="font-bold text-grey-darker block mb-2">Email</label>
            <input v-model="email" type="text" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow" placeholder="Email">
          </div>
          <div class="mb-4">
            <label class="font-bold text-grey-darker block mb-2">Passwort</label>
            <input v-model="password" type="password" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow" placeholder="Passwort">
          </div>
          <div class="text-center">
            <button type="submit" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Login</button>
          </div>
        </form>
      </div>
      <div class="text-center">
        <p class="text-grey-dark text-sm"><a class="no-underline inline-block align-baseline font-bold text-sm text-blue hover:text-blue-dark" href="#">Passwort vergessen?</a></p>
        <p class="text-grey-dark text-sm">Noch keinen Account?
          <router-link to="/sign-up" class="no-underline text-blue font-bold">Registrieren</router-link>.</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'login',
    data: function () {
      return {
        error: '',
        email: '',
        password: '',
        phoneNumber: ''
      }
    },
    methods: {
      close: function () {
        this.error = false
      },
      signIn: function () {
        this.$root.$data.firebase.app.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$router.push({
              name: 'services'
            })
          },
          (err) => {
            this.error = err.message
          }
        )
      },
      signInWithGoogle: function () {
        let provider = this.$root.$data.firebase.googleProvider
        this.$root.$data.firebase.app.auth().signInWithPopup(provider).then(
          (result) => {
            this.$router.push({
              name: 'services'
            })
          },
          (err) => {
            this.error = err.message
          }
        )
      },
      signInWithFacebook: function () {
        let provider = this.$root.$data.firebase.facebookProvider
        this.$root.$data.firebase.app.auth().signInWithPopup(provider).then(
          (result) => {
            this.$router.push({
              name: 'services'
            })
          },
          (err) => {
            this.error = err.message
          }
        )
      },
      signInWithPhone: function () {
        window.recaptchaVerifier = new this.$root.$data.firebase.auth.RecaptchaVerifier('sign-in-button', {
          'size': 'invisible',
          'callback': function (response) {
    // reCAPTCHA solved, allow signInWithPhoneNumber.
            this.signInWithPhone2()
          }
        })
      },
      signInWithPhone2: function () {
        var appVerifier = window.recaptchaVerifier
        this.$root.$data.firebase.app.auth().signInWithPhoneNumber(this.phoneNumber, appVerifier).then(
          (result) => {
            this.$router.push({
              name: 'services'
            })
          },
          (err) => {
            this.error = err.message
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Login.vue